import { SyntheticEvent, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import useAppSelector from "@/core/helpers/useAppSelector";
import { Modal } from "@/shared/ui";
import { Country } from "@/domains/account/constants/country";
import { countriesSelector } from "@/domains/account/slice";
import useSmsCode from "@/domains/playerMenu/hooks/useSmsCode";
import PlayerMenuSettingsSafetyEnableTfaSMSCheckContainer from "@/domains/playerMenu/containers/settings/safety/tfa/check-enable/PlayerMenuSettingsSafetyEnableTfaSMSCheckContainer";
import PlayerMenuSettingsSafetyEnableTfaSMSSend from "@/domains/playerMenu/components/settings/safety/tfa/PlayerMenuSettingsSafetyEnableTfaSMSSend";

type Props = {
  onClose: () => void;
};

export default function PlayerMenuSettingsSafetyEnableTfaSMSContainer({ onClose }: Props) {
  const { t } = useTranslation("account");
  const countries = useAppSelector(countriesSelector);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [country, setCountry] = useState<Country>(Country.Russia);
  const { sendCodeHandler, sendIsPending, sendError, sendIsCompleted } = useSmsCode();

  const currCountry = useMemo(() => {
    const findedCountry = countries.find((item) => item.country === country);
    return findedCountry;
  }, [countries, country]);

  const onSubmit = useCallback(
    async (e: SyntheticEvent<HTMLFormElement>) => {
      e.preventDefault();
      sendCodeHandler(`${currCountry.code}${phoneNumber}`);
    },
    [phoneNumber, currCountry],
  );

  const onChangeCountry = useCallback((value: Country) => {
    setCountry(value);
  }, []);

  const onPhoneNumberChageHandler = useCallback((phone: string) => {
    let value = phone;
    if (value.length > 10) {
      value = value.slice(0, 10);
    }
    setPhoneNumber(value);
  }, []);

  const title = t(sendIsCompleted ? "account.confirmPhoneNumber" : "account.enableTfaSms");

  return (
    <Modal open onClose={onClose} title={title} className="h-[49rem]">
      {sendIsCompleted ? (
        <PlayerMenuSettingsSafetyEnableTfaSMSCheckContainer
          address={`${currCountry.code}${phoneNumber}`}
          onClose={onClose}
        />
      ) : (
        <PlayerMenuSettingsSafetyEnableTfaSMSSend
          error={sendError}
          phoneNumber={phoneNumber}
          onPhoneNumberChange={onPhoneNumberChageHandler}
          onSubmit={onSubmit}
          countries={countries}
          country={currCountry}
          onChangeCountry={onChangeCountry}
          pending={sendIsPending}
        />
      )}
    </Modal>
  );
}
